module.exports = __webpack_public_path__ + "img/security-audit-img-4.ba3fca58.webp";